import Vue from 'vue';
import integrationApi from '@/api/integration';
import tagApi from '@/api/tag';

const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_ACCOUNTS = 'SET_ACCOUNTS';
const ADD_ACCOUNT = 'ADD_ACCOUNT';
const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
const REMOVE_ACCOUNT = 'REMOVE_ACCOUNT';
const SET_TAG = 'SET_TAG';
const REMOVE_TAG = 'REMOVE_TAG';
const ADD_TAG = 'ADD_TAG';

const state = {
	isFetching: false,
	accounts: [],
	tags: [],
};

const getters = {
	isFetching: state => state.isFetching,
	accounts: state => state.accounts,
	tags: state => state.tags,
};

const mutations = {
	[SET_IS_FETCHING](state, value) {
		state.isFetching = value;
	},
	[SET_ACCOUNTS](state, accounts) {
		state.accounts = accounts;
	},
	[ADD_ACCOUNT](state, account) {
		state.accounts.push(account);
	},
	[UPDATE_ACCOUNT](state, updatedAccount) {
		const index = state.accounts.findIndex(account => account._id === updatedAccount._id);
		if (index !== -1) {
			Vue.set(state.accounts, index, updatedAccount);
		}
	},
	[REMOVE_ACCOUNT](state, id) {
		const index = state.accounts.findIndex(account => account._id === id);
		if (index !== -1) {
			state.accounts.splice(index, 1);
		}
	},
	[SET_TAG](state, tags) {
		state.tags = tags.filter((el, index) => tags.indexOf(el) === index);
	},
	[ADD_TAG](state, tag) {
		state.tags = state.tags.concat(tag);
	},
	[REMOVE_TAG](state, id) {
		const index = state.tags.findIndex(tag => tag._id === id);
		if (index !== -1) {
			state.tags.splice(index, 1);
		}
	},

};

const actions = {
	fetchAccounts({ commit }, params = {}) {
		commit(SET_IS_FETCHING, true);
		const callback = (response) => {
			const accounts = response.data;
			commit(SET_ACCOUNTS, accounts);
			commit(SET_IS_FETCHING, false);
		};
		integrationApi.getAccounts(params, callback);
	},
	setAccounts({ commit }, accounts) {
		commit(SET_ACCOUNTS, accounts);
	},
	addAccount({ commit }, account) {
		commit(ADD_ACCOUNT, account);
	},
	updateAccount({ commit }, account) {
		commit(UPDATE_ACCOUNT, account);
	},
	removeAccount({ commit }, id) {
		commit(REMOVE_ACCOUNT, id);
	},
	// tags
	getTags({ commit }, params) {
		const callback = (response) => {
			const tags = response.data;
			if (tags.length !== 0) {
				commit(SET_TAG, tags);
			}
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
		};
		tagApi.getTags(params, callback, errorCallback);
	},
	setTag({ commit }, tag) {
		commit(SET_TAG, tag);
	},
	appendTag({ commit }, tag) {
		commit(ADD_TAG, tag);
	},
	deleteTag({ commit }, id) {
		commit(REMOVE_TAG, id);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
